import { render, staticRenderFns } from "./ZoomLive.vue?vue&type=template&id=72dc6806&scoped=true"
import script from "./ZoomLive.vue?vue&type=script&lang=js"
export * from "./ZoomLive.vue?vue&type=script&lang=js"
import style0 from "./ZoomLive.vue?vue&type=style&index=0&id=72dc6806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc6806",
  null
  
)

export default component.exports